"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ratingItems = _interopRequireDefault(require("./ratingItems"));

var _utils = require("../../libs/utils");

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _fieldset = _interopRequireDefault(require("./styled/fieldset"));

var _label = _interopRequireDefault(require("./styled/label"));

/** @category Form */
var Rating =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Rating, _Component);

  function Rating(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Rating);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Rating).call(this, props));
    _this.state = {
      value: props.value
    };
    _this.starGroupNameId = (0, _utils.uniqueId)('starGroup');
    _this.handleOnHover = _this.handleOnHover.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleOnLeave = _this.handleOnLeave.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Rating, [{
    key: "getName",
    value: function getName() {
      var name = this.props.name;

      if (name) {
        return name;
      }

      return this.starGroupNameId;
    }
  }, {
    key: "handleOnHover",
    value: function handleOnHover(event) {
      var readOnly = this.props.readOnly;

      if (event.target.value && !readOnly) {
        return this.setState({
          value: event.target.value
        });
      }

      return null;
    }
  }, {
    key: "handleOnLeave",
    value: function handleOnLeave() {
      return this.setState({
        value: this.props.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className,
          onChange = _this$props.onChange,
          label = _this$props.label,
          readOnly = _this$props.readOnly;
      var value = this.state.value;
      return _react["default"].createElement(_fieldset["default"], {
        onMouseOver: this.handleOnHover,
        onMouseLeave: this.handleOnLeave,
        className: className,
        style: style
      }, _react["default"].createElement(_RenderIf["default"], {
        isTrue: !!label
      }, _react["default"].createElement(_label["default"], null, label)), _react["default"].createElement(_ratingItems["default"], {
        onChange: onChange,
        value: value,
        name: this.getName(),
        readOnly: readOnly
      }));
    }
  }]);
  return Rating;
}(_react.Component);

exports["default"] = Rating;
Rating.propTypes = {
  /** The value of the rating stars. This value defaults to 0. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** The action triggered when a value attribute changes. */
  onChange: _propTypes["default"].func,

  /** An identifier for the group of radio items. */
  name: _propTypes["default"].string,

  /** The rating label */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object,

  /** Specifies that the Rating is read-only. This value defaults to false. */
  readOnly: _propTypes["default"].bool
};
Rating.defaultProps = {
  value: 0,
  onChange: function onChange() {},
  name: undefined,
  label: null,
  className: undefined,
  style: undefined,
  readOnly: false
};